import React, { Component, Fragment } from 'react';


import Core from './../../Core/Core'
import ErrorManager from '../../Core/ErrorManager';

import OpinionModal from './OpinionModal';

class Opinions extends Component
{
    constructor(props)
    {
        super(props);

        this.edit = this.edit.bind(this);
        this.delete = this.delete.bind(this);
    }


    edit(id)
    {
        window.location.href = "/opinion/edit/"+id
    }

    delete(id)
    {
        if(!window.confirm("Etes-vous sûr de vouloir supprimer cet élément ?"))
            return;
        Core.Instance.Request(Core.Address+"Opinion/"+id, null, "DELETE").then((json)=> {
            ErrorManager.Instance.Info("L'élément a bien été supprimé.");
            window.location.reload();
        });
        
    }
    
    getColorFromNote(note){
        if(note == 10 || note == 9){
            return 'badge-success'
        }else if(note == 8 || note == 7){
            return 'badge-warning'
        }else{
            return 'badge-danger'
        }
    }

    render()
    {
        let opinions = this.props.opinions == null ? [] :
        this.props.opinions.map((e) => {
            let date = e.date != null ? (new Date(e.date*1000)) : null;
            if(date != null)
                date = date.getDate().toString().padStart(2, "0")+"/"+(date.getMonth()+1).toString().padStart(2, "0")+"/"+date.getFullYear();
            return (
                <Fragment>
                    <tr key={e.id}>
                        <td>{ e.source ? e.source : '/'}</td>
                        <td>{ e.dealership ? e.dealership : '/'}</td>
                        <td>{ e.service ? e.service : '/'}</td>
                        <td><span className={`badge ${this.getColorFromNote(e.note)}`}>{ e.note }/10</span></td>
                        <td>{ date }</td>
                        <td className="font-weight-normal text-truncate">{ e.comment ? e.comment : '/'}</td>
                        <td className="text-right">
                            <a className="text-secondary" data-toggle="modal" data-target={ "#opinion"+e.id }>
                                <i className="far fa-eye"></i>
                            </a>
                            {
                                this.props.editing == true && 
                                <Fragment>
                                    <span className='fas fa-edit ml-2' onClick={ (ev) => { ev.preventDefault();this.props.loadOpinion(e.id) }}/>
                                    <span className='far fa-trash-alt ml-2' onClick={ (ev) => { ev.preventDefault();this.delete(e.id) } }/>
                                </Fragment>
                            }
                        </td>
                    </tr>
                    <OpinionModal index={e.id} opinion={e}/>
                </Fragment>
            );
        });
        return (
            <div>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Source</th>
                            <th>Concession</th>
                            <th>Service</th>
                            <th>Note</th>
                            <th>Date</th>
                            <th>Commentaire</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className="">
                        { opinions }
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Opinions;


// WEBPACK FOOTER //
// ./src/Components/Opinion/Opinions.js